import { skipToken } from "@reduxjs/toolkit/query";

import { usePatientOptional } from "features/patients/use-patient.hook";
import { useGetUserQuery } from "services/users";

type ReportProviderRef = {
  appointment?: { staffMember?: { id?: number } | null } | null;
} | null;

export default function useHideUltraHighFrequencies(
  report?: ReportProviderRef,
  options?: { skip?: boolean }
): boolean {
  const patient = usePatientOptional()?.patient;

  const providerId = options?.skip
    ? undefined
    : (report?.appointment?.staffMember?.id ?? patient?.preferred_provider?.id);

  const { data: provider } = useGetUserQuery(providerId ?? skipToken);

  return Boolean(
    provider?.user_preferences?.reporting?.hide_ultra_high_frequencies
  );
}
